import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import './TopUpBalance.scss';
import { TopUpBankCard } from '../../components/topUpBalanceParts/TopUpBankCard';
import { TopUpRouteNames } from '../../models/Common';
import { Page404 } from '../404';

interface topUpBalanceVariant {
  component: JSX.Element;
  routePath: TopUpRouteNames;
  isExact?: boolean;
}

export const TopUpBalance: FC = () => {
  const { path } = useRouteMatch();
  const topUpBalancePages: topUpBalanceVariant[] = [
    {
      component: <TopUpBankCard />,
      routePath: TopUpRouteNames.BankCard,
      isExact: true,
    },
    { component: <Page404 />, routePath: TopUpRouteNames.Page404 },
  ];
  return (
    <div className="top-up-balance-page page">
      <div className="top-up-balance-page__container container">
        <Switch>
          {topUpBalancePages.map((page) => {
            return (
              <Route exact={page.isExact} path={page.routePath && path.concat(page.routePath)} key={page.routePath}>
                {page.component}
              </Route>
            );
          })}
        </Switch>
      </div>
    </div>
  );
};
